var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.900391 3.4377C0.900391 3.10859 1.16719 2.8418 1.4963 2.8418H13.4621C13.7912 2.8418 14.058 3.10859 14.058 3.4377V15.4034C14.058 15.7325 13.7912 15.9993 13.4621 15.9993H1.4963C1.16719 15.9993 0.900391 15.7325 0.900391 15.4034V3.4377ZM2.0922 4.03361V14.8075H12.8662V4.03361H2.0922Z",
    fill: "#0F20E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47872 5.58984C7.80783 5.58984 8.07463 5.85664 8.07463 6.18575V12.6633C8.07463 12.9924 7.80783 13.2592 7.47872 13.2592C7.14961 13.2592 6.88281 12.9924 6.88281 12.6633V6.18575C6.88281 5.85664 7.14961 5.58984 7.47872 5.58984Z",
    fill: "#0F20E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32052 5.58984C4.64963 5.58984 4.91642 5.85664 4.91642 6.18575V12.6633C4.91642 12.9924 4.64963 13.2592 4.32052 13.2592C3.99141 13.2592 3.72461 12.9924 3.72461 12.6633V6.18575C3.72461 5.85664 3.99141 5.58984 4.32052 5.58984Z",
    fill: "#0F20E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5588 5.58984C10.8879 5.58984 11.1547 5.85664 11.1547 6.18575V12.6633C11.1547 12.9924 10.8879 13.2592 10.5588 13.2592C10.2297 13.2592 9.96289 12.9924 9.96289 12.6633V6.18575C9.96289 5.85664 10.2297 5.58984 10.5588 5.58984Z",
    fill: "#0F20E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.4377C0 3.10859 0.266796 2.8418 0.595906 2.8418H14.3554C14.6845 2.8418 14.9513 3.10859 14.9513 3.4377C14.9513 3.76681 14.6845 4.03361 14.3554 4.03361H0.595906C0.266796 4.03361 0 3.76681 0 3.4377Z",
    fill: "#0F20E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.86328 2.65772C4.86328 1.19042 6.05373 0 7.52102 0C8.9883 0 10.1788 1.19042 10.1788 2.65772C10.1788 2.98683 9.91197 3.25363 9.58286 3.25363C9.25375 3.25363 8.98695 2.98683 8.98695 2.65772C8.98695 1.84866 8.3301 1.19181 7.52102 1.19181C6.71194 1.19181 6.05509 1.84866 6.05509 2.65772C6.05509 2.98683 5.7883 3.25363 5.45919 3.25363C5.13008 3.25363 4.86328 2.98683 4.86328 2.65772Z",
    fill: "#0F20E8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.18ab8d980b23d0be11bdfa9b630a9b38.svg";
export { ForwardRef as ReactComponent };